import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';

interface PageHeaderProps {
  title: string;
  description: string;
  items: { label: string; to?: string }[];
}

export default function PageHeader({ title, description, items }: PageHeaderProps) {
  return (
    <div className="border-b border-background-300/60 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 py-8 md:py-10">
        <Breadcrumb items={items} />
        <h1 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
          {title}
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-3xl">{description}</p>
      </div>
    </div>
  );
}